module.exports = __webpack_public_path__ + "static/media/logo.1e78742f.svg";